var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-dashboard-item',{staticClass:"metric",attrs:{"theme":_vm.theme,"width":_vm.width,"height":_vm.height}},[_c('div',{staticClass:"metric-value"},[_vm._v(_vm._s(_vm.value)),(_vm.unit)?_c('small',[_vm._v(_vm._s(_vm.unit))]):_vm._e()]),_c('div',{staticClass:"metric-label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }